import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear, faUpload } from "@fortawesome/free-solid-svg-icons";
import { Button, Card, Row, Col } from "react-bootstrap";

const EventPhotosStats = ({ id_name, storage }) => {
  const navigate = useNavigate();
  if (!storage) return null;

  return (
    <Card className="shadow-sm border-0 mt-3">
      <Card.Body>
        {/* <Card.Title className="mb-3 fw-bold">Photos</Card.Title> */}
        <Card.Title className="mb-2 d-flex justify-content-between align-items-center">
          <h5 className="fw-bold">Storage</h5>
          {id_name && (
            <div className="d-flex gap-2">
              <Button
                size="sm"
                variant="outline-secondary"
                onClick={() => navigate(`/admin/${id_name}`)}
              >
                <FontAwesomeIcon icon={faGear} className="me-2" /> Edit gallery
              </Button>
              <Button
                size="sm"
                variant="outline-success"
                onClick={() => navigate(`/admin/upload/${id_name}`)}
              >
                <FontAwesomeIcon icon={faUpload} className="me-2" /> Upload
              </Button>
            </div>
          )}
        </Card.Title>
        {/* Total photos */}
        <Row className="mb-2">
          <Col xs={6} className="fw-semibold text-muted">
            Photos:
          </Col>
          <Col>{storage?.total_images ?? "N/A"}</Col>
        </Row>
        {/* Memory used */}
        <Row className="mb-2">
          <Col xs={6} className="fw-semibold text-muted">
            Memory used:
          </Col>
          <Col>
            {storage?.used_memory
              ? `${(storage.used_memory / 1024 / 1024).toFixed(1)} MB`
              : 0}
          </Col>
        </Row>
        {/* TODO: add instagram fb et site clicks stats */}
      </Card.Body>
    </Card>
  );
};

export default EventPhotosStats;
